module.exports = __webpack_public_path__ + "img/logo-medialog@3x.a322146b.png";